<template>
  <component :is="componentToShow" />
</template>

<script>
import {authUser} from '@/utils/auth';
import adminDashboard from '@/views/pages/dashboard/admin-dashboard/admin-dashboard.vue';
import superDashboard from '@/views/pages/dashboard/super-dashboard/super-dashboard.vue';

export default {
  data() {
    return {
      componentToShow: null,
    };
  },
  created() {
    const user = authUser();
    if(user?.type === 'SUPER_ADMIN'){
     this.componentToShow = superDashboard;
    }else{
     this.componentToShow = adminDashboard;
    }
  },
};
</script>
